'404':
  goBack: Go to home
  notFound: Page not found.
about:
  cloudCommunity:
    description: >-
      By building an open-source and open cloud native technology ecosystem,
      exploring cloud native technology innovation, promoting the development of
      cloud native technology in China, and empowering the digital
      transformation of various industries.
    duty1: >-
      Explore and build an open-source ecosystem of cloud native industry
      software to promote the development of cloud native production industry.
    duty2: Improve the technical usability and reliability of our community.
    duty3: >-
      Promote the promotion, use, promotion, and training of open source
      software within this community.
    duty4: Other authorized scope by the foundation.
    title: OpenAtom Cloud Community
  council:
    title: Board Members
  infoAbout:
    introduction: >-
      The OpenAtom Foundation is a non-profit organization dedicated to
      promoting the development of the global open source communiyt. Established
      in Beijing in June 2020, the Foundation adheres to the core principles of
      co-construction, co-governance, and sharing. It positions itself as a
      developer-centric platform for incubating open source projects and
      delivering public-interest technology services. The Foundation aims to
      systematically build an open and collaborative open source ecosystem,
      enhance industry-wide cooperation efficiency, and empower a broad range of
      sectors.


      The Foundation is committed to operating and incubating a portfolio of
      open source projects with global impact. Key projects currently under its
      stewardship include OpenHarmony, targeting the Internet of Everything;
      openEuler, focused on digital infrastructure; openKylin, a desktop
      operating system; OpenTenBase, a high-performance database; OpenLoong,
      centered on humanoid robotics; and OpenLET, an embodied AI open source
      dataset. Through these initiatives, the Foundation continues to build the
      industrial foundation for open source innovation.


      To support project development, the Foundation provides a wide array of
      public services, including communications and outreach, legal assistance,
      funding support, technical enablement, and open governance. These efforts
      aim to foster, protect, and promote the development and application of
      open source software, while advancing the prosperity and sustainability of
      open source projects.


      The Foundation's activities span across fundraising, dedicated grants,
      public communications, education and training, academic exchange,
      international cooperation, compliance consulting, and ecosystem
      development. Guided by the strategic framework of "Two Conferences, Two
      Initiatives, One Competition, and One Platform", the Foundation strives to
      cultivate a vibrant open source culture, attract broader participation,
      and enhance China's influence in the global open source arena, ultimately
      contributing to the creation of a thriving open source ecosystem.
    title: About Us
  organizationStructure:
    department1: Department of Business Development
    department10: Open Source Competition Organizing Committee
    department2: Operations Department
    department3: Department of Legal Affairs and Intellectual Property
    department4: Branding Department
    department5: R&D Department
    department6: Finance Department
    department7: Department of General Affairs
    department8: Education Department
    department9: Research Department
    scrollHint: ← Scroll left and right to view the full structure →
    structure1:
      content: >-
        The Board of Directors reviews and amends the bylaws of the Foundation,
        among other duties. The board chair, vice chairs, and secretary-general
        are elected and appointed from board members. The board chair is the
        legal representative of OpenAtom.
      title: The Board of Directors
    structure2:
      content: >-
        As a neutral technical decision-making body, TOC is responsible for
        making tech-related decisions and evaluating incubation projects, among
        others.
      title: Technical Oversight Committee (TOC)
    structure3:
      content: >-
        Authorized by the Board of Directors, the Open Source Security Committee
        is responsible for the planning, coordinating and implementation of open
        source security-related processes, projects, tools, standards, external
        cooperation and other work.
      title: Open Source Security Committee
    structure4:
      content: >-
        As the executive body of OpenAtom, the Secretariat manages daily
        operations of the Foundation, with a dedicated team providing a range of
        support concerning legal affairs, marketing, community operations, and
        infrastructure construction. It consists of nine departments:
      title: Secretariat
    title: Structure
  securityCommitee:
    description: >-
      The Open Source Security Committee is responsible for the planning,
      coordinating and implementation of the Foundation's security-related work.
      Its duties include:
    duty1: >-
      Offering advice on open source security to the Foundation and its
      incubation projects.
    duty2: Making the Foundation's work plan and budget of open source security.
    duty3: >-
      Establishing the Foundation's general rules and principles for open source
      security, including relevant decision-making mechanisms and processes.
    duty4: >-
      Initiating open source security-related projects, tools, and platforms
      needed by the Foundation.
    duty5: Engaging in international cooperation related to open source security.
    duty6: >-
      Developing relevant standards for and publishing white papers on open
      source security.
    duty7: Carrying out the education and promotion of open source security.
    duty8: Finishing other relevant work authorized by the Board of Directors.
    group:
      title1: 牵头单位：
      title2: 安全标准工作组成果介绍
    member:
      title1: 常务理事单位
      title2: 成员单位
    standing:
      title1: 开源安全委员会常务委员会
  technicalOversightCommitee:
    description: >-
      At the OpenAtom Foundation (OpenAtom), the Technical Oversight Committee
      (TOC) provides technical guidance for the Foundation's open source
      projects. It undertakes duties including:
    duty1: >-
      Providing technical vision and guidance to the Foundation from a global
      perspective.
    duty2: >-
      Reviewing and approving the incubation and graduation of open source
      projects.
    duty3: >-
      Delegating duties to mentors, examining and approving the list of the
      mentor pool.
    duty4: Promoting cross-project collaboration to avoid redundancy and conflicts.
    duty5: >-
      Receiving feedback from the Users' Committee to enable continuous
      improvement of the projects.
    duty6: Facilitating the formation of ecological connectivity across projects.
    duty7: >-
      Defining open source-related routine practices (such as principles and
      procedures).
    mentor:
      description: 是技术监督委员会（TOC）指导下的外部专家团队，拥有如下权责利：
      duty1: 辅导基金会的项目孵化，每季度提交项目孵化报告
      duty2: 定期参加辅导项目PMC会议并在项目毕业时给出意见
      duty3: 可得基金会颁发导师证书和基金会官网个人品牌展现
      duty4: 参加基金会各项公开活动并作为演讲嘉宾出席TOC活动
      duty5: 可作为基金会大会的分论坛出品人
      duty6: 可应邀出席TOC内部的线下或者线上会议，发表意见
      duty7: 表现突出导师可个人身份经基金会投票选举成为TOC成员
      more: View More
      position: Mentor
      title: TOC 导师团
    title: Technical Oversight Committee (TOC)
  title: About Us
caseStudy:
  description: >-
    Project practitioners are sharing their implementation stories, bringing
    technical discussions back to real industry scenarios
  detail:
    backToList: Back to Industry Application Cases
    contact: Contact
    industry: Industry
    partner: Partner
    publishDate: Published
    technology: Technology
  empty: No cases available
  filter:
    all: All
    industry:
      education: Education
      finance: Finance
      label: Industry
      manufacturing: Manufacturing
      medical: Healthcare
      retail: Retail
    searchPlaceholder: Search case names, partners, etc.
    technology:
      label: Project
  keepUpdating: Continuously updating...
  search: Search
  shareButton: Start Sharing
  statistics: '{count} cases available for you, continuously updating...'
  title: Industry Application Cases
certification:
  detail:
    exam:
      label1: ''
      label2: ''
      label3: ''
      link: ''
      number: ''
    title1: Certification Framework
    title2: Certification Courses
    title3: Certification Process
    title4: ''
    title4desc: ''
    title5: ''
    title5desc: ''
    title6: ''
    title6desc: ''
    title7: Authorized Training Partner
  index:
    more: View More
    partner: Authorized Training Partner Program
    title: Open Source Talent Certification
cooperation:
  navigator1: Financial Giving
  navigator2: Host A Project
  navigator3: OpenAtom Partnership
  partner:
    contributor1: Platinum Sponsorship
    contributor2: Gold Sponsorship
    contributor3: Silver Sponsorship
    contributor4: Open Source Contributors
    contributorNotice: ' Note: Donors with * are at the stage of agreement-signing.'
    information:
      title: Information Disclosure
    searchCategoryAll: All
    searchInputPlaceholder: Search the Site
    searchInputTitle1: Historical Search
    searchInputTitle2: Recommended Search
    tableEmpty: Empty
    tableHead1: Serial Number
    tableHead2: Donor
    tableHead3: Donee
    tableHead4: Level of Sponsorship
    title: OpenAtom Partnership
  projectDonate:
    projectStepList:
      desc2: The donor submits project files.
      desc3: OpenAtom reviews project files.
      desc4: >-
        Technical Oversight Committee (TOC) conducts a further review for
        incubation decisions.
      desc5: OpenAtom reviews project codes.
      desc6: Both parties sign the donation agreement.
      title2: Submit the Files
      title3: Review the Files
      title4: Review the Project
      title5: Review the Codes
      title6: Sign an Agreement
    projectStepTitle: Guide to Host A Project
    subTitle: >-
      We provide professional services to OpenAtom incubated open source
      projects.
    table:
      category1:
        children:
          sub1:
            children:
              content1: Project Financial Support
            title: Financial Support
          sub2:
            children:
              content1: Project Fundraising
            title: Fundraising
          sub3:
            children:
              content1: Project Escrow
              content2: Project Financial Management
            title: Escrow
          sub4:
            children:
              content1: Project Procurement Services
            title: Project Procurement
          sub5:
            children:
              content1: Compliance Audit for Projects
            title: Financial Audit
        title: Financial Services
      category2:
        children:
          sub1:
            children:
              content1: Template for Project Governance Bylaws
              content2: Project Organizational Structure and Role Settings
              content3: Template for Project Collaboration and Management Processes
              content4: Project Documentation Guidelines
              content5: Project Contribution Guidelines
              content6: Executive Secretary Appointed by OpenAtom
              content7: Recruitment Services Provided by OpenAtom
            title: Project Governance
          sub2:
            children:
              content1: Code Compliance Analysis
              content2: >-
                Compliance Strategies, Planning and Evaluation for Open Source
                Projects
            title: Compliance Governance
          sub3:
            children:
              content1: Guide to Building Community Leadership
              content2: Guide to Community User Growth
              content3: Guide to Community Contributor Incentive Plan
            title: Community Governance
        title: Governance Services
      category3:
        children:
          sub1:
            children:
              content1: Brand Promotion via OpenAtom New Media Matrix
              content2: Participation in OpenAtom Promotion Campaigns
            title: Brand Promotion
          sub2:
            children:
              content1: Exclusive Exhibition Booths at OpenAtom Conferences
              content2: Organizing Sub-forums at OpenAtom Conferences
              content3: Co-organizing Events with OpenAtom
            title: Event Marketing
          sub3:
            children:
              content1: Trademark Design
              content2: Trademark Registration
            title: Trademark Services
        title: Marketing Services
      category4:
        children:
          sub1:
            children:
              content1: Open Source License Management and Risk Assessment
            title: Open Source Licenses
          sub2:
            children:
              content1: Open Source IP Management and Risk Assessment
            title: Open Source Intellectual Property (IP)
          sub3:
            children:
              content1: Contract Review and Professional Legal Advice
            title: Contract Services
        title: Legal Services
      category5:
        children:
          sub1:
            children:
              content1: Assigning Professional Mentors to Projects
              content2: Providing Mentorship Plans Based on Project Progress
              content3: Evaluating the Maturity and Health of Projects
            title: Project Mentors
        title: Mentorship
      category6:
        children:
          sub1:
            children:
              content1: Guide to Workshop Organization
              content2: Event Planning, Organization, and Implementation of Workshops
            title: Workshops
          sub2:
            children:
              content1: Guide to the Developer Grow-up Plan
              content2: >-
                Event Planning, Organization, and Implementation of the
                Developer Grow-up Plan
            title: Developer Grow-up Plan
        title: Services for Developers
      category7:
        children:
          sub1:
            children:
              content1: Mentorship Certification Training
              content2: Developer Certification Training
            title: Certification Training
        title: Training Services
      category8:
        children:
          sub1:
            children:
              content1: Use and Maintenance of OpenAtom General Account
            title: Account Management
          sub2:
            children:
              content1: Guidelines for Git Code Hosting Management
              content2: CLA/DCO on Git Code Hosting Platform
              content3: CI/CD on Git Code Hosting Platform
            title: Code Hosting
          sub3:
            children:
              content1: Code Compliance Analysis.
            title: Code Compliance
          sub4:
            children:
              content1: Website Design, Development, Operation and Maintenance
            title: Website Building
          sub5:
            children:
              content1: Development of IT Infrastructure (such as forums and wiki pages)
            title: Other IT Infrastructure
        title: IT Infrastructure Development
      category9:
        children:
          sub1:
            children:
              content1: BD Support from OpenAtom
              content2: Communication with Our Sponsors
            title: BD Support
        title: Ecosystem Extension
      head1: Categories of Services
      head2: Subcategories
      head3: Items
    title: Host A Project
  title: Make a Donation to OpenAtom!
  titleDescription: >-
    As the first open source foundation in China, we invite more tech companies
    to join us and work closely with other donors, so as to promote the
    development of open source projects and ecosystems. With our resources and
    professional services, you will be able to experience closely the best open
    source practices. By attracting partners and speeding the iteration, you can
    set up your own open source strategies. You will become a participant and a
    pioneer to define and defend the standards of cutting-edge open source
    technologies. As a neutral organization working transparently on the needs
    of open source developers, we strive to promote open source collaboration
    and innovation, thereby sharing the fruits of open source technologies.
  titleSmall: Let's work together to create a better era for open source!
  unSpecialPanel:
    content: >-
      Enterprises, organizations or individuals can make non-targeted financial
      donations to OpenAtom. If the donor does not limit the donation to
      specific activities or projects, it will be coordinated and used by the
      Foundation for various services that are in line with its purpose,
      including the maintenance and services of the infrastructure of open
      source projects, the protection of OpenAtom's trademarks, and the support
      needed for various open source empowerment programs. With all these, we
      can promote the spread of open source culture, the active and prosperous
      development of open source community, and ensure the sustainable
      development of open source projects.
    extraordinaryRule: 10 million CNY/year (minimum)
    extraordinaryTitle: Extraordinary Sponsorship
    goldRule: 1 million CNY/year (minimum) for no less than 2 consecutive years
    goldTitle: Gold Sponsorship
    platinumRule: 3 million CNY/year (minimum) for no less than 3 consecutive years
    platinumTitle: Platinum Sponsorship
    silverRule: 200,000 CNY/year (minimum)
    silverTitle: Silver Sponsorship
    title: General Sponsorship
  welfareDonate:
    contentList:
      desc1: The donor signs a non-disclosure letter with OpenAtom.
      desc2: >-
        Both parties sign the donation agreement (funding/project) with their
        stamps on it.
      desc3: The donor makes the donation.
      desc4: OpenAtom issues a donation receipt to the donor.
      desc5: OpenAtom promotes the donor's brand exposure.
      title1: Sign a Non-disclosure Letter
      title2: Sign an Agreement
      title3: Make the Donation
      title4: Invoice the Donor
      title5: Brand Promotion
    email: ' Email: sponsorship{''@''}openatom.org '
    specialTabpanel:
      list1: >-
        In addition to general financial donations, companies, organizations, or
        individuals are also welcome to make targeted ones to OpenAtom's
        specific events, projects, or programs.
      list2: >-
        While supporting public welfare undertakings and fulfilling your social
        responsibilities, you will also have the opportunity to get more
        involved in the event, project, or program you are interested in.
    telephone: 'For financial giving, please contact:   TEL: 010-59258678*8007 '
    title: Financial Giving
    welfareTab:
      contentTitle: Guide to Financial Giving
      title1: General Sponsorship
      title2: Targeted Sponsorship
events:
  actionCity: City
  actionReset: Reset
  actionSearch: Search
  actionTitle: Title
  actionYear: Year
  info1: This Month
  info2: Our has a total of{0}events.
  info3: Currently in full swing.
  info4: Looking forward to meeting you in{0}!
  notFound: Event not found
  placeholder1: Please enter
  placeholder2: All
  regionAll: All
  regionEmpty: No options
  regionNotFound: Not Found
  regionOnline: Online
  title: Events
footer:
  address: >-
    Contact Us: 2201, 22nd Floor, Building 8, No. 8 Kegu 1st Street, Beijing
    Economic-Technological Development Area, Beijing
  beian: J. ICP B. No. 2020036654-1
  content1: Privacy Policy
  content10: 'Host A Project: '
  content11: 'Legal Issues: '
  content12: Copyright © OpenAtom Foundation. All rights reserved.
  content13: J.G.W.A.B. No. 11030102011597
  content2: Website Terms of Use
  content3: Brand Usage Guidelines
  content4: Download OpenAtom Foundation Logos
  content5: 'Media Cooperation: '
  content6: 'Feedback and Suggestions: '
  content7: 'Looking for Suppliers: '
  content8: 'Career Opportunities: '
  content9: 'Financial Giving: '
  emailError: Invalid email format
  emailInfo: >
    By subscribing, you agree to receive emails from OpenAtom Foundation
    regarding news, events, and other content. You can unsubscribe at any time.
    For information about our privacy practices and our commitment to protecting
    your privacy, please review our privacy policy. We do not disclose your
    contact information to third parties.
  emailTitle: >-
    Stay Updated with OpenAtom Foundation - Get the Latest News, Events, and
    More!
  info: Information usage
  information: >-
    The OpenAtom Foundation is a non-profit organization dedicated to promoting
    the development of the global open source cause, which was established in
    Beijing in June 2020.
  nameError: Please fill in your name
  placegolderEmail: email
  placegolderName: name
  subscribe: Subscribe now
  subscribeSuccess: You have successfully subscribed
header:
  about:
    content1:
      item1:
        desc: ''
        title: About Us
      item2:
        desc: ''
        title: Structure
      item3:
        desc: ''
        title: Board Members
      title: About Us
    content2:
      item1:
        desc: ''
        title: Technical Oversight Committee (TOC)
      item2:
        desc: 了解哪些单位为我们提供安全保障工作
        title: Open Source Security Committee
      item3:
        desc: ''
        title: OpenAtom Cloud Community
      title: ''
  cooperation:
    content1:
      item1:
        desc: ''
        title: Financial Donation
      item2:
        desc: ''
        title: Project Funding
      item3:
        desc: ''
        title: Our Partner
      title: Cooperation
    content2:
      item1:
        desc: ''
        title: Donation Procedure
      item2:
        desc: ''
        title: Project Call for Support
      item3:
        desc: ''
        title: Contact Us
      item4:
        desc: ''
        title: FAQ
      title: Additional Information
  events:
    content1:
      item1:
        title: Open Source Operations Hub
    content2:
      item2:
        title: 2026 OpenAtom open source ECO-Conference
  nav1: Home
  nav2: Projects
  nav3: Cooperation
  nav4: About Us
  nav5:
    children:
      nav1: OpenAtom Open Source Talent Training Program
      nav2: OpenAtom Contest
      nav3: FOSS Legal
      nav4: Insight
      nav5: Open Source Talent Certification
      title1: Public Welfare
      title2: Events
    title: Events
  nav6:
    children:
      nav1: OpenAtom Global Open Source Summit
      nav2: 🔥The 2026 OpenAtom Developer Conference
      nav3: Events
    title: ''
  project:
    content1:
      item1:
        title: Projects in Incubation
      item2:
        title: Incubation Preparatory Period
      item3:
        title: Archived Projects
      item4:
        title: Graduated Projects
      title: All Projects
    content2:
      item1:
        desc: >-
          Covering full-scenario applications, and supporting a variety of
          devices.
        title: OpenHarmony
      item2:
        desc: An open-source operating system for digital infrastructure
        title: openEuler
      item3:
        desc: An open-source operating system deeply integrated with AI technology
        title: openKylin
      item4:
        desc: >-
          A distributed database with core capabilities that is compatible with
          traditional commercial databases, supporting both OLTP and OLAP
          capabilities.
        title: OpenTenBase
      title: Star Projects
  resource:
    item1:
      title: OpenAtom Open Source Talent TrainingProgram
    item2:
      title: OpenAtom Contest
    item3:
      title: FOSS Legal
    item6:
      title: 🔥The 2026 OpenAtom Developer Conference
    item7:
      title: Project Service Platform
    title: Resources and Tools
home:
  banner:
    button1: Financial Donation
    button2: Project Funding
    button3: Partnership Opportunities
    title1: OpenAtom Contest
    title2: OpenAtom Open Source Talent Training Program
    title3: ATOMGIT Code Repository
    title4: OpenAtom open source Eco-Conference 2024
  bottomBanner:
    title: We recommend AtomGit! Let's change the world with codes!
    view: View
  caseStudy:
    aiGenerated: AI-generated image
    contact: 'Contact: '
    partner: 'Co-builder: '
    partyA: 'Client: '
    subtitle: Let's go to the frontline of project implementation.
    title: Open Source, Brilliant Through Application.
    viewAll: All Industry Application Cases
    viewDetail: View Details
  contributors:
    donationDetails: View Details
    donationOfFundsIntroduce: Contribute to the open source cause!
    donationOfFundsIntroduce1: >-
      We will work closely with you to incubate your projects, build your open
      source ecosystems, establish milestone frameworks, and create your open
      source communities.
    donationOffunds: Financial Giving
    more: More Donors
    platinumDonor: Platinum Sponsorship
    projectDonation: Project Contribution
    projectDonation1: >-
      Companies, organizations and individuals are welcome to donate open source
      projects!
    projectDonation2: >-
      We will work closely with you to incubate your projects, build your open
      source ecosystems, establish milestone frameworks, and create your open
      source communities.
    title: Make a Donation to OpenAtom!
  event:
    content1:
      description: Software Defines the World, Open Source Builds the Future
  exploreProjects:
    allItems: All Projects
    desc1: 以下项目按照协议签署时间排序
    incubate: Incubation
    ourProject: Our Projects
  info:
    numberIntroduce1: |-
      毕业、孵化
      开源项目
    numberIntroduce2: |-
      通过
      TOC评审项目
    numberIntroduce3: Total Volume of Project Code
    numberIntroduce4: Total Number of Contributors
  infoWills:
    title: Our Vision
  information:
    content1:
      button: Donate Now
      desc: >-
        Technology enterprises are cordially invited to join the OpenAtom
        Foundation's Donor Program. Your support will directly empower the open
        source innovation ecosystem, accelerating the incubation and adoption of
        cutting-edge technologies. As a core partner, you will deeply connect
        with top developers, enhance technical influence and brand reputation,
        and jointly lead a new era of open collaboration.
      title1: DONORS
      title2: Become a Creator in the Open Source Era
    content2:
      button: Start Contributing
      desc: >-
        All developers are welcome! Submit your first contribution (PR, etc.) to
        instantly become a project contributor. We sincerely invite you to go
        further: participate in issue discussions and collaborate on new feature
        development. Active contributors will be invited to join core community
        groups, deeply engage in project evolution, and collectively shape the
        future of open source!
      title1: CONTRIBUTORS
      title2: Build Open Source Projects Together
    content3:
      button: Join Community
      desc: >-
        The Open Source Operations Zone is a SaaS platform launched by the
        foundation for regional governments, universities, vertical industries,
        and open-source enterprises. It enables the establishment of dedicated
        open-source communities to aggregate resources and co-build brands.
        Built on a Git+CMS architecture with multi-platform data integration, it
        seamlessly connects resources such as the "Open Source Talent Training
        Program" initiative and open-source competitions. The platform offers
        capabilities including data insights, talent assessment, and integration
        with local computing resources.
      title1: Community
      title2: Explore the Open Source Community Together
  more: Learn More
  openSourceService:
    content: For More Services
    introduce1: Strategic Consultancy
    introduce2: Legal Support
    introduce3: Project Operations
    introduce4: Marketing & Branding
    title: Open Source Services
  services:
    button: Service application
    content1:
      desc: Based on AtomGit, provides open source community SaaS services
      tag1: ''
      tag2: ''
      tag3: ''
      title: Open Source Operations Hub
    content2:
      desc: AtomGit is a high-performance open source collaboration platform
      tag1: ''
      tag2: ''
      tag3: ''
      title: ATOMGIT
    content3:
      desc: >-
        Provides resource application services to promote open source ecosystem
        development
      tag1: ''
      tag2: ''
      tag3: ''
      title: Resource Application
    content4:
      desc: >-
        Provides legal consultation for open source license selection, code
        compliance analysis, trademark lifecycle management, etc.
      tag1: ''
      tag2: ''
      tag3: ''
      title: Legal Enablement
    content5:
      desc: >-
        Promotes open source culture, enhances brand visibility of open source
        projects, and facilitates project development
      tag1: ''
      tag2: ''
      tag3: ''
      title: Brand Promotion
    content6:
      desc: >-
        Professional governance to support the long-term development of open
        source projects
      tag1: ''
      tag2: ''
      tag3: ''
      title: Project Operations
    desc: >-
      Providing one-stop open source operation solutions, breaking brand
      barriers, integrating project data, and efficiently connecting developers,
      resources, and ecosystem partners. Services include resource application,
      brand promotion, legal support, and professional project
      governance—empowering open source projects throughout their lifecycle and
      accelerating innovation and growth.
    title: Our Open Source Services
  slogan: >-
    To promote open source collaboration and innovation. To share the fruits of
    open source projects.
  welfare:
    content: View All Projects
    lawList:
      description1: This Community aims to build open source consensus via translation.
      description2: >-
        Focusing on open-source, free public welfare courses are designed for
        in-house counsels, lawyers, developers, and managers.
      description3: >-
        To usher in a new era of communications among legal professionals in the
        open-source field.
      name1: Contransus™ Translation Community
      name2: PrincipOS
      name3: OSHeart
      title1: Translation
      title2: Courses
      title3: Legal Salon
    lawTitle: Open Source {0}
    lawTitlePrimary: Legal
    title1: Contribute to
    title2: Open source public welfare.
    topic1:
      content: >-
        {0} It also nurtures open source talents, promotes the open source
        social responsibility of technological innovation-based enterprises,
        accelerates open source innovation among the general public, and
        facilitates high-quality development in the software industry.
      contentPrimary: >-
        Launching nationwide OpenAtom Open Source Talent Training Program
        activities disseminates open source culture from the "source".
      title: OpenAtom {0}
      titlePrimary: Open Source Talent Training Program
    topic2:
      content: >-
        {0} It aims to bring together resources from various open source
        organizations, companies, institutions, universities, primary and
        secondary schools, research institutes, industry associations,
        institutional investors and financing agencies.
      contentPrimary: >-
        The first "OpenAtom Open Source Contest" was launched by the OpenAtom
        Foundation.
      title: OpenAtom {0}
      titlePrimary: Open Source Contest
languageName: English
law:
  database:
    more: Read full content
    title: Legal Resource Database
    title2: Law
    title3: Regulations
  lectures:
    title1: '"PrincipOS"Public Welfare Courses'
    title2: Public Welfare Courses For Comprehensive Open-Source Knowledge System
  licence:
    title1: OpenAtom Licenses
  salon:
    title1: OSHeart Legal Salon
  translation:
    pepele1:
      name: ZHOU Minghui
      title: Professor
    pepele2:
      name: WEI Sir
      title: Engineer
    pepele3:
      name: SHEN Fen
      title: Counsel
    pepele4:
      name: SONG Lei
      title: Professor
    pepele5:
      name: XU Meiling
      title: Assistant Professor
    title1: Contransus™ Translation Community
projects:
  detail:
    number1: Commits
    number2: Stars
    number3: Contributors
    number4: Watches
    number5: Forks
    number6: PRs
    title1: Download Projects
    title2: Project Codes
    title3: Project Communities
  index:
    briefIntroduction1: >-
      The OpenAtom Foundation is dedicated to building a sustainable ecosystem
      for open source project development, enhancing strategic project layout,
      and fostering the cultivation of open source projects.
    codeCabin1: Code Repository
    codeCabin2: Repository
    details1: View More Details
    details2: View More Details
    foundationService: OpenAtom Open Source Services
    moreProjects: View More Projects
    project1: Open Source Projects
    project2: Projects in Incubation
    project3: Incubation Preparatory Period
    project4: Archived
    project5: Graduated Projects
    serviceTabList:
      content:
        comment1: >-
          Offering strategic planning in open source industry trends analysis,
          technological innovation, industry standards, ecosystem development,
          and advanced innovation processes.
        comment10: >-
          Formulating open source governance standards from various dimensions
          such as developers, open source projects, communities, and
          enterprises, building an open source software evaluation framework.
        comment11: >-
          Regularly hosting developer workshops, open source technology salons,
          workshops, and other open source events, implementing developer
          incentive plans, and fostering diverse collaborations across open
          source communities.
        comment12: >-
          Utilizing the core code hosting platform AtomGit, providing a
          comprehensive range of services and guidance necessary for the
          operation of open source projects.
        comment17: Creating official websites and omnimedia communication channels.
        comment18: >-
          Regular marketing for open source technology trends and project
          progress.
        comment19: Brand building and operation for open source projects from zero.
        comment2: >-
          R&D process optimization, version control, code compliance, and open
          source risks.
        comment20: Design and development of products related to open source culture.
        comment21: >-
          Hosting open source summits, developer conferences, open source
          contests, and similar events.
        comment22: >-
          Engaging students and educators in open source activities, integrating
          theory with practical application.
        comment23: >-
          Organizing and implementing the "Open Source Way to School" public
          service project, guiding schools in establishing open source clubs and
          promoting open source culture.
        comment24: >-
          Selecting ambassadors and advocates for the "Open Source Way to
          School," cultivating open source mentors.
        comment25: >-
          Creating introductory open source courses and coordinating efforts to
          provide courses on contributing to open source projects.
        comment26: >-
          Integrating the foundation's open source projects into campuses for
          collaborative development and nurturing open source talent.
        comment27: >-
          Promoting open source projects, fundamental open source principles,
          and collaborative open source methodologies.
        comment3: >-
          License compatibility, license compliance, and copyright infringement
          risks.
        comment4: >-
          The structure of open source organizations and communities, the design
          of high-level processes, the design of open source and closed source
          frameworks, and the development of technical standards.
        comment5: >-
          Open source license compliance advice, open source license
          compatibility analysis, etc.
        comment6: >-
          Training on open source governance compliance, the Yuanguilv (Rules of
          Open Source) lectures, etc.
        comment7: >-
          Charitable legal services and activities: professional forums on open
          source compliance, Xinjiyuan (Legal Issues of Open Source) seminars,
          etc.
        comment8: >-
          Open source case studies, open source license drafting, open source
          standardization, etc.
        comment9: >-
          Achieving open source project certification tests, releasing the
          latest versions of open source projects, and assisting in the
          incubation and graduation of open source projects.
        title1: Open Source Strategic Planning
        title10: Open Source Project Governance Systems
        title11: Open Source Technology-themed Events
        title12: Open Source Infrastructure
        title17: Establishing a Multimedia Communication Platform
        title18: Regular Marketing for Targeted Projects
        title19: Building Open Source Project Branding
        title2: Consulting on Open Source R&D and Management
        title20: Hosting Large-Scale Events Related to Open Source
        title21: Creating an Open Source Culture Framework
        title22: Conducting Open Source Education Activities and Training
        title23: Nurturing a Reserve of Open Source Talent in Tertiary Education
        title24: Enthusiastic Engagement of Open Source Volunteers
        title25: Constructing a Comprehensive Open Source Courses
        title26: Cultivating Student Developers and Contributors in Open Source
        title27: Promoting Open Source Culture and Fundamental Principles
        title3: Compliance Guidance for Open Source Codes
        title4: Strategy Implementation Design
        title5: Open Source Compliance Legal Consultation
        title6: Open Source Compliance Legal Training
        title7: Charitable Legal Services and Activities
        title8: Legal Research
        title9: Open Source Project Management Services
      title1: Strategic Consultancy
      title2: Legal Support
      title3: Project Operations
      title4: Marketing & Branding
      title5: Open Source Education and Training
    title1: Donor(s)
    title2: Contributor(s)
    title3: Project Values
    title4: Technical Features
    title5: Project Sponsor(s)
    website1: Official Website
    website2: Website
unsubscribe:
  action2: Resubscribe
  desc: 'Please tell us why you choose to unsubscribe:'
  desc2: >
    We're sorry that you've decided to unsubscribe, but we appreciate your
    ongoing support. We are committed to providing high-quality content to our
    users, and we also understand your needs and choices. You can {0} at any
    time in case of any needs. If you have any questions or need some help
    regarding cancelling the subscription, please feel free to contact us
    anytime at report{'@'}openatom.org. Thank you for your understanding and
    support!
  desc3: >-
    Thank you for subscribing to our latest updates. You will receive our latest
    news first, keeping you informed about our news and events.

    Thank you for your support!
  placeholder: ' Please enter your reason'
  reson1: I don't want to receive these messages anymore.
  reson2: ' I never subscribed to this mailing list.'
  reson3: The email content is not helpful to me.
  reson4: Other
  resubscribe: Subscribed Successfully
  success: Unsubscribed successfully
  title: Unsubscribe
websiteDescription: >-
  The OpenAtom Foundation is a non-profit organization dedicated to promoting
  the development of the global open source communiyt. Established in Beijing in
  June 2020, the Foundation adheres to the core principles of co-construction,
  co-governance, and sharing. It positions itself as a developer-centric
  platform for incubating open source projects and delivering public-interest
  technology services. The Foundation aims to systematically build an open and
  collaborative open source ecosystem, enhance industry-wide cooperation
  efficiency, and empower a broad range of sectors.
websiteKeywords: >-
  OpenAtom Foundation, non-profit organization, global open source community,
  Beijing, June 2020, technology companies, Alibaba, Baidu, Huawei, Inspur, 360,
  Tencent, China Merchants Bank, open source incubation, collaboration
  framework, international open source community, fundraising, publicity,
  education, international cooperation, open source ecology, consulting
  services, software development, legal assistance, fund support, technical
  support, open governance, sustainable development, China's contribution
websiteTitle:
  about: About Us
  brandGuide: Brand Usage Guidelines
  caseStudy: Industry Application Cases
  certification: Open Source Talent Certification
  contact: Contact Details
  cooperation: Cooperation
  default: OpenAtom Foundation
  events: Events
  insight: ''
  privacyPolicy: Privacy Policy
  projects: Open Source Projects
  terms: Website Terms of Use
  unsubscribe: unsubscribe
